export class VendorAchDetailDto {
  accountType: string;
  recipientType: string;
  companyName: string;
  accountNumber: string;
  remittanceEmail: string;
  accountRoutingNumber: string;
}
